/**
 * 联系方式的唯一来源。改邮箱/链接只改这里，
 * footer、侧栏、/space、/space/about 全部从这里消费。
 */

export const contacts = {
  github: 'https://github.com/zkbkb',
  linkedin: 'https://linkedin.com/in/kaibin-zhang',
  twitter: 'https://x.com/zzkbkb',
  bluesky: 'https://bsky.app/profile/zkbkb.bsky.social',
  email: 'kaibin.zhang.23@ucl.ac.uk',
  emailHref: 'mailto:kaibin.zhang.23@ucl.ac.uk'
} as const;
